import { useState } from "react";
import { useRecoilState } from "recoil";
import waitingRoomState from "../../../atoms/waiting-room";
import emitCheckRoomPassword from "../../../connector/emits/checkRoomPassword";
import { SHA256 } from "../../../utility/security";
import "./EnteringSecretRoom.scoped.scss"

function EnteringSecretRoom() {
  const [waitingRoom, setWaitingRoom] = useRecoilState(waitingRoomState);

  const [password, setPassword] = useState('');

  const closeThis = () => {
    setWaitingRoom({
      ...waitingRoom,
      isOpenedEnteringSecretRoom: false,
    })
  };

  const enterRoom = () => {
    const encryptedPassword = SHA256(password);
    setWaitingRoom({ 
      ...waitingRoom,
      tryingEncryptedPassword: encryptedPassword,
     });
    emitCheckRoomPassword(waitingRoom.tryingRoomId, encryptedPassword);
  };

  return (
    <div className="entering-secret-room-warpper">
      <div className="entering-secret-room">
        <div className="entering-secret-room__header">
          <div>비밀 채팅방 입장하기</div>
          <button onClick={closeThis}>X</button>
        </div>
        <div className="entering-secret-room__contents">
          <div className="entering-secret-room__row">
            <div className="entering-secret-room__row-title">비밀번호</div>
            <div className="entering-secret-room__row-input">
              <input 
                type="password" 
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>
          <div className="entering-secret-room__button">
            <button onClick={enterRoom}>입장하기</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EnteringSecretRoom;